import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";

import NotFound from "@/components/[routes]/not-found";
import ProviderWrapper from "@/components/providers/provider-wrapper";
import { AuthContext } from "@/core/auth/auth";

interface RouterContext {
  auth: AuthContext;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound,
});

function RootComponent() {
  return (
    <ProviderWrapper>
      <Outlet />
    </ProviderWrapper>
  );
}
